export default "__VITE_ASSET__4462dde7__"